import { useLayoutEffect } from 'react';
import { useNavTabs } from 'App/components/Navtabs';
import { useNavegate } from 'App/hooks';
import { IonPageStratus } from 'commons/components';
import { openWindow } from 'commons/utils/window';
import {
  useAdminLinks,
  useIsMobileDevice,
  useStoreStatus,
} from 'domains/Auth/hooks';
import useLogout from 'domains/Auth/pages/LogoutPage/useLogout';
import { CHECKOUT_ROUTES } from 'domains/Billing/Checkout/checkoutRoutes';
import { useStoreChurnedStatus } from 'domains/Billing/hooks';
import { useStoreInfo } from 'domains/PartnersApps/hooks';
import { DisabledStoreContent, HandoffStore } from './components';
import useReviveStore from '../../hooks/useReviveStore';
import { trackingBillingReactivateClick } from '../../tracking';
import './CanceledStorePage.scss';

function CanceledStorePage() {
  const { hideSideBar, hideNavTabs, showNavTabs } = useNavTabs();
  const { pathname } = useNavegate();
  const { canReactivateWithoutPayment } = useStoreChurnedStatus();
  const { goTo } = useNavegate();
  const { handleReviveStore } = useReviveStore();
  const logout = useLogout();
  const isMobileDevice = useIsMobileDevice();
  const { getNewAdminLink } = useAdminLinks();

  useLayoutEffect(() => {
    hideSideBar();
    hideNavTabs();

    return () => {
      showNavTabs();
    };
  }, [hideSideBar, hideNavTabs, showNavTabs]);

  const handleRecoverStore = async () => {
    trackingBillingReactivateClick(pathname);
    if (canReactivateWithoutPayment) {
      await handleReviveStore();
    } else {
      if (isMobileDevice) {
        openWindow(
          getNewAdminLink(CHECKOUT_ROUTES.plansAndSubscriptions),
          true,
        );
      } else {
        goTo(CHECKOUT_ROUTES.plansAndSubscriptions);
      }
    }
  };

  const { hasFirstPayment } = useStoreInfo();
  const { storeStatus } = useStoreStatus();

  if (!hasFirstPayment && storeStatus === 'store_down') {
    return <HandoffStore handleRecoverStore={handleRecoverStore} />;
  }

  return (
    <div className="stratus--canceled-store-page">
      <IonPageStratus>
        <DisabledStoreContent
          handleRecoverStore={handleRecoverStore}
          logout={logout}
        />
      </IonPageStratus>
    </div>
  );
}

export default CanceledStorePage;
